import styled from 'styled-components'

export const DisplayBtn = styled.button`
  width: 7.4375rem;
`
